/**
 * package: com.inq.ui
 * class: CommandParser
 * @extends com.inq.ui.Container
 * @constructor
 */
com.inq.ui.CommandParser = function() {
	com.inq.ui.Container.call(this);
};
$hxClasses.extend(com.inq.ui.Container, com.inq.ui.CommandParser, "com.inq.ui.CommandParser");

/**
 * evaluateSymbolicReference - takes symbolic values and parses them into string value.
 * The symbolic values are parsed from the FlashVars, the client Window, or from the Client Document and ...
 * it can get the value of the: top, bottom, left, and right positions of any named canvas and ...
 * it can retrieve the value of the width or height of any named canvas.
 *
 * examples:
 * FlashVars.chatID						results in "000105020201" or whatever the chat id is
 * Window.name								results in the name of the window as a string
 * Window.location.href					results in the client window's URL as a string
 * FlashVars.agentName						results in "Jessica"
 * InputField.first_name					produces "Fred" where the values are retrieved from form field with the id of "first_name"
 * Chat.top								Gets the position of the top of the chat
 * Chat.bottom 							Gets the position of the bottom of the chat
 *
 * $type TFun([{ name => value, t => TInst(String,[]), opt => false }],TInst(String,[]))
 * public static function evaluateSymbolicReference(value:String):String
 * @public
 * @static
 * @param {string}  value - Position as a string, it can contain references relative to other containers' position
 * @return {string} - The position evaluated from "value" as a string
 */
com.inq.ui.CommandParser.evaluateSymbolicReference = function(value) {
	/** @type {Array} */
	var a = value.split(".");
	/** @type {string} */
	var nameContainer = a.shift();
	/** @type {Window} */
	var clientWindow = window.parent;
	/** @type {Document} */
	var clientDocument = clientWindow.document;
	/** @type {string} */
	var key = a.join(".");
	if(nameContainer == "FlashVars") return com.inq.flash.client.control.FlashVars.get(key); else if(nameContainer == "Window") {
		/** @type {Window} */
		var obj = clientWindow;
		try {
			key = a.shift();
			while(key != null) if(obj[key] != null) {
				obj = obj[key];

				// Check to make sure that we are not referencing the IJSF window via the Client window
				if (obj == window) {
					throw "Cannot access IJSF internals: " + value;
				}
				key = a.shift();
			} else throw "Item " + key + " not found in " + value;
		} catch( e ) {
			throw "Window item not accessible: " + Std.string(e);
		}
		return "" + Std.string(obj);
	} else if(nameContainer == "InputField") {
		try {
			/** @type {?HTMLElement} */
			var el = com.inq.ui.Container._getElementById(key,clientDocument);
			if(el != null) {
				if(el.value != null) return el.value;
			}
		} catch( e ) {
			haxe.Log.trace("Window item not accessible: " + Std.string(e),{ fileName : "CommandParser.hx", lineNumber : 75, className : "com.inq.ui.CommandParser", methodName : "evaluateSymbolicReference"});
		}
		return "";
	} else {
		/** @type {com.inq.ui.Container} */
		var c = Application.application.getMxmlItem(nameContainer);
		/** @type {number} */
		var iVal = 0;
		if(c != null) {
			switch(key) {
				case "top":
					iVal = c.getY();
					break;
				case "left":
					iVal = c.getX();
					break;
				case "right":
					iVal = c.getX() + c.getWidth();
					break;
				case "bottom":
					iVal = c.getY() + c.getHeight();
					break;
				case "width":
					iVal = c.getWidth();
					break;
				case "height":
					iVal = c.getHeight();
					break;
				case "visible":
					iVal = c.getVisible();
					break;
				default:
					iVal = 0;
			}
			return "" + iVal;
		}
	}
	return "0";
};


/**
 * InitializeKeywordMap - private static,
 * This populates the keyword map, it is done at load time, only once
 * The reason we do this is that we want the map keys to be character strings
 * An xpath representation will break on obfuscation.
 *
 * $type TFun([],TAnonymous(<anonymous>))
 * private static function InitializeKeywordMap()
 * @private
 * @static
 * @return {TAnonymous(<anonymous>)}
 */
com.inq.ui.CommandParser.InitializeKeywordMap = function() {
	/** @type {Object} */
	var keywordMap = { };
	keywordMap["IF"] = "if(";
	keywordMap["THEN"] = "){";
	keywordMap["ELSE"] = "}else{";
	keywordMap["END"] = "}";
	keywordMap["TRUE"] = "(true)";
	keywordMap["FALSE"] = "(false)";
	keywordMap["AND"] = "&&";
	keywordMap["OR"] = "||";
	keywordMap["EQ"] = "==";
	keywordMap["NE"] = "!=";
	keywordMap["NOT"] = "!";
	return keywordMap;
};


/**
 * getNextToken
 * This gets tokens from left to right, on at a time
 * When a token is not valid, this routine throws an exception
 *
 * $type TFun([{ name => commandString, t => TInst(String,[]), opt => false },{ name => offset, t => TInst(Int,[]), opt => true }],TDynamic(null))
 * private static function getNextToken(commandString:String, ?offset:Int = 0):Dynamic
 * @private
 * @static
 * @param {string}  commandString - the command string to be parsed
 * @param {number}  offset - offset at which to parse
 * @return {Object} - a JSON object containing the token and the new offset
 */
com.inq.ui.CommandParser.getNextToken = function (commandString, offset) {
	if (offset == null) {
		offset = 0;
	}

	/** @type {string} */
	var s = HxOverrides.substr(commandString,offset,null);
	/** @type {EReg} */
	var regStringLiteral = new EReg("^([\"'])(?:(?=(\\\\?))\\2.)*?\\1","m");
	/** @type {EReg} */
	var regNumber = new EReg("^([-+]?\\d+(\\.\\d+)?)","m");
	/** @type {EReg} */
	var regKeyword = new EReg("^\\b(IF|THEN|ELSE|END|TRUE|FALSE|AND|OR|EQ|NE|NOT)\\b","m");
	/** @type {EReg} */
	var regProperties = new EReg("^\\b((\\w*)(\\.(\\w*)\\b)+)\\b","m");
	/** @type {EReg} */
	var regFuncs = new EReg("^(email|hide|show|hideLayer|showLayer|shrink|grow|fire|popout|close|send|call|minimize|restore|resizeChatWindow|init|play|pause)\\b","m");
	/** @type {EReg} */
	var regTwoParam = new EReg("^\\b((resizeChatWindow)\\s*\\(\\s*(\\d+)\\s*,\\s*(\\d+)\\s*\\))\\s*","m");
	/** @type {EReg} */
	var regOneParam = new EReg("^\\b((hide|show|hideLayer|showLayer|shrink|grow|fire|init|play|pause)\\s*\\(\\s*([\\w\\.]+)\\s*\\))\\s*","m");
	/** @type {EReg} */
	var regNoParams = new EReg("^(\\b(close|popout|send|call|minimize|email|restore)\\(\\s*\\))\\s*","m");
	/** @type {?string} */
	var token1 = null;
	var parameter = "";
	/** @type {string} */
	var firstChar = s.charAt(0);

	// remove white space
	while(" \t\r\n".indexOf(firstChar) != -1) {
		++offset;
		s = HxOverrides.substr(s,1,null);
		firstChar = s.charAt(0);
	}

	if(s == "") token1 = ""; else if(firstChar == "'" || firstChar == "\"") {
		if(regStringLiteral.match(s)) {
			token1 = regStringLiteral.matched(0);
			offset += token1.length;
		} else {
			com.inq.ui.CommandParser.showErrorLocation(commandString,offset);
			throw "invalid literal at offset " + offset + " token in: " + commandString;
		}
	} else if (regNumber.match(s)) {
		// Next check for number such as 123 (integer) or 3.152 (floating point)
		token1 = regNumber.matched(0);
		offset += token1.length;
	} else if (regKeyword.match(s)) {
		// Check for keywords such as IF THEN ELSE END
		token1 = regKeyword.matched(0);
		offset += token1.length;
		token1 = com.inq.ui.CommandParser.KEYWORD_MAP[token1];
	} else if (regProperties.match(s)) {
		/*
		 * Check for properties, the format of a property is
		 * xxxx.yyyy where xxxx is the object and yyyy is the property name
		 * For Window it can have a more complex xpath
		 */
		token1 = regProperties.matched(0);
		offset += token1.length;

		/** @type {string} */
		var valu = com.inq.ui.CommandParser.evaluateSymbolicReference(token1);

		if (valu === true || valu === false || valu === "true" || valu === "false") {
			// If this is true or false, then return it with no quotes
			token1 = "" + Std.string(valu);
		} else if (regNumber.match("" + Std.string(valu))) {
			// If this is a numeric, then return it with no quotes
			token1 = "" + Std.string(valu);
		} else {
			token1 = com.inq.utils.StringUtil.toJsonString("" + Std.string(valu));
		}
	} else if (regFuncs.match(s)) {
		// Check for functions, then check for particular functions
		/** @type {string} */
		var funcName = regFuncs.matched(0);
		if(regOneParam.match(s)) {
			token1 = regOneParam.matched(0);
			offset += token1.length;
			token1 = "exposedCmds." + funcName + "(" + com.inq.utils.StringUtil.toJsonString(regOneParam.matched(3)) + ");";
		} else if (regTwoParam.match(s)) {
			token1 = regTwoParam.matched(0);
			offset += token1.length;
			parameter = regTwoParam.matched(3) + "," + regTwoParam.matched(4);
			token1 = "exposedCmds." + funcName
				+ "(" + com.inq.utils.StringUtil.toJsonString(parameter) + ");";
		} else if(regNoParams.match(s)) {
			token1 = regNoParams.matched(0);
			offset += token1.length;
			token1 = "exposedCmds." + funcName + "();";
		} else {
			com.inq.ui.CommandParser.showErrorLocation(commandString,offset + funcName.length);
			throw "Invalid parameter for function " + funcName + " at offset " + offset + funcName.length + " token in: " + commandString;
		}
	} else {
		com.inq.ui.CommandParser.showErrorLocation(commandString,offset);
		throw "Invalid token at offset " + offset + " token in: " + commandString;
	}

	/** @type {string} */
	var remainder = HxOverrides.substr(commandString, offset, null);

	return { token: token1, remainder: remainder, offset: offset };
};

/**
 * showErrorLocation
 *
 * $type TFun([{ name => logicString, t => TInst(String,[]), opt => false },{ name => offset, t => TInst(Int,[]), opt => false }],TEnum(Void,[]))
 * private static function showErrorLocation(logicString:String, offset:Int):Void
 * @private
 * @static
 * @param {string}  logicString
 * @param {number}  offset
 * @return {void}
 */
com.inq.ui.CommandParser.showErrorLocation = function(logicString,offset) {
	/** @type {string} */
	var position = "";
	/** @type {EReg} */
	var regNotWhiteSpace = new EReg("\\S","gm");/*  REGEX to match all non white space*/
	position = regNotWhiteSpace.replace(logicString," ");/*  Replace all non white space to space*/
	position = HxOverrides.substr(position,0,offset) + "^";/*  Put caret at the location of the error*/
	haxe.Log.trace("Error in logic string:\n" + logicString + "\n" + position,{ fileName : "CommandParser.hx", lineNumber : 231, className : "com.inq.ui.CommandParser", methodName : "showErrorLocation"});
};


/**
 * executeLogic
 *
 * @param {string} logicString - string with command
 * @param {boolean} test - if true, will stub out the commands in the listener logic to prevent them from executing.
 * If false or undefined, will fully attach listeners and execute them.
 * @param {com.inq.ui.Container} container - container
 *
 * @return {boolean} true if command was executed successfully,
 *                   false if error occurred
 */
com.inq.ui.CommandParser.executeLogic = function (logicString, test, container) {
	if (test == null) {
		test = false;
	}

	if (logicString == null || logicString == "") {
		return true;
	}

	/** @type {string} */
	var command = "";
	/** @type {number} */
	var off = 0;
	/** @type {Object} */
	var ob;
	try {
		do {
			ob = com.inq.ui.CommandParser.getNextToken(logicString, off);
			command += Std.string(ob.token);
			off = ob.offset;
		} while (ob.remainder !== "");

		/** @type {Function} */
		var noop = function () {};

		/** @type {Object} */
		var exposedCmds = {};

		if (test) {
			exposedCmds["hide"] = noop;
			exposedCmds["show"] = noop;
			exposedCmds["hideLayer"] = noop;
			exposedCmds["showLayer"] = noop;
			exposedCmds["grow"] = noop;
			exposedCmds["shrink"] = noop;
			exposedCmds["close"] = noop;
			exposedCmds["popout"] = noop;
			exposedCmds["send"] = noop;
			exposedCmds["call"] = noop;
			exposedCmds["fire"] = noop;
			exposedCmds["minimize"] = noop;
			exposedCmds["restore"] = noop;
			exposedCmds["resizeChatWindow"] = noop;
			exposedCmds["email"] = noop;
		} else {
			exposedCmds["hide"] = com.inq.ui.Container.hide;
			exposedCmds["show"] = com.inq.ui.Container.show;
			exposedCmds["hideLayer"] = com.inq.flash.client.control.XFrameWorker.hideLayer;
			exposedCmds["showLayer"] = com.inq.flash.client.control.XFrameWorker.showLayer;
			exposedCmds["grow"] = com.inq.flash.client.control.XFrameWorker.grow;
			exposedCmds["shrink"] = com.inq.flash.client.control.XFrameWorker.shrink;
			exposedCmds["close"] = com.inq.flash.client.chatskins.SkinControl.actionBtnCloseChat;
			exposedCmds["popout"] = com.inq.flash.client.chatskins.SkinControl.actionBtnPopOut;
			exposedCmds["send"] = com.inq.flash.client.chatskins.SkinControl.actionBtnSend;
			exposedCmds["call"] = com.inq.flash.client.chatskins.SkinControl.actionBtnCall;
			exposedCmds["fire"] = com.inq.flash.client.chatskins.SkinControl.fireCustomEvent;
			exposedCmds["minimize"] = com.inq.flash.client.control.MinimizeManager.actionMinimize;
			exposedCmds["restore"] = com.inq.flash.client.control.MinimizeManager.actionRestore;
			exposedCmds["resizeChatWindow"] = Application.ResizeStage;
			exposedCmds["email"] = com.inq.flash.client.chatskins.EmailMgr.actionBtnSendEmail;
			exposedCmds["init"] = com.inq.ui.Container.initializeClass;
			exposedCmds["play"] = com.inq.ui.Container.playVideo;
			exposedCmds["pause"] = com.inq.ui.Container.closeVideo;
			exposedCmds["stop"] = com.inq.ui.Container.stopVideo;
		}

		window["exposedCmds"] = exposedCmds;

		/**
		 * input: exposedCmds.fire("ShrinkBottomFrame");"
		 * output: split more than one exposed commands by semicolon
		 * @type {Array}
		 */
		var cmds = command.split(/;/);


		for (var i = 0; i < cmds.length; i++) {
			if (cmds[i]) {
				/*
				 * Below regex will return all the items, examples:
				 * ["exposedCmds", "fire", "", "ShrinkBottomFrame", "", ""]
				 * ["exposedCmds", "resizeChatWindow", "", "350,500", "", ""]
				 */
				/** @type {?Array} */
				var cmd = cmds[i].split(/[.[\]'"()]/);

				// Below code will execute the exposed command and its parameter
				if (cmd !== null && cmd.length > 3) {
					var params = cmd[3] ? cmd[3].split(",") : [];
					exposedCmds[cmd[1]].apply(this, params);
				}
			}
		}
	} catch (e) {
		haxe.Log.trace(
			"Could not run event on component " + container.getID()
			+ "\nfor: " + logicString + "\nError:" + Std.string(e)
			+ "\nJS: " + command,
			{
				fileName: "CommandParser.js",
				lineNumber: 387,
				className: "com.inq.ui.CommandParser",
				methodName: "executeLogic"
			}
		);

		return false;
	}

	return true;
};


/**
 * addListeners
 * Add listeners associated with the MXML
 * Currently we only are interested in "onClick"
 *
 * $type TFun([],TEnum(Void,[]))
 * public static function addListeners()
 * @public
 * @static
 * @see Application.hx method run
 * @return {void}
 */
com.inq.ui.CommandParser.addListeners = function() {
	/** @type {Array} */
	var cntrKeys = Application.keySet();
	/** @type {com.inq.ui.Container} */
	var cntr;
	/** @type {string} */
	var key;
	while (cntrKeys.length > 0) {
		key = cntrKeys.pop();
		cntr = Application.getContainer(key);
		if (cntr != null) {
			cntr.addMxmlListeners();
		}
	}
};

/** @type {com.inq.ui.CommandParser} */
com.inq.ui.CommandParser.prototype.__class__ = com.inq.ui.CommandParser;
/** @private @type {string} */
com.inq.ui.CommandParser.WHITESPACE = " \t\r\n";

/** @private @type {null} */
com.inq.ui.CommandParser.KEYWORD_MAP = com.inq.ui.CommandParser.InitializeKeywordMap();

